<template>
  <div class="mit-admin-generate-reset-link-page mit-page">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card fluid">
              <v-card-title>Generate Reset Password Link</v-card-title>
              <v-card-subtitle class="caption">Generate a reset password link for users. </v-card-subtitle>
              <v-divider></v-divider>

        <v-card v-if="!finished">
            <v-card-title>Enter User Information</v-card-title>
            <v-card-text>
              <v-form ref="linkForm" v-model="valid" lazy-validation>
                  <v-select :items="resetChoices" v-model="changeModel.type"
                    required
                    :hint="changeModel.type.hint"
                    item-text="name"
                    return-object
                    item-value="id" filled label="Reset method" :rules="rules.resetType">
                  </v-select>
                  <v-text-field v-model="changeModel.username" label="CSAIL username" :rules="rules.username"></v-text-field>
                  <v-text-field v-model="changeModel.expireTime" label="Link expire time (minutes):" :rules="rules.expireTime"></v-text-field>
                  <v-text-field v-model="changeModel.resetPin" label="PIN (optional)">
                      <template v-slot:append>
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                                  mdi-help-circle-outline
                                </v-icon>
                              </template>
                              <span>If a value is entered here, a user will be required to enter this pin upon resetting their password. This can be any alpha numeric text. Leave empty if you don't want to require a pin.</span>
                          </v-tooltip>
                      </template>
                  </v-text-field>
                  <v-btn color="primary" @click="submit()">Submit</v-btn>
              </v-form>
            </v-card-text>
        </v-card>
        <v-card v-if="finished">
            <v-card-title>{{resultModel.title}}</v-card-title>
            <v-card-text>
                <v-col v-if="loading" class="d-flex justify-center align-center">
                  <v-row>
                    <BaseMitLoading class="pa-10"/>
                  </v-row>
                </v-col>

                <div v-if="!loading"">

                  <div class="pb-10"> {{resultModel.message}}</div>
                  <div v-if="changeModel.type.id === 'link'">
                      <v-textarea id="mit-reset-link" filled no-resize name="input-link" label="Reset Link" v-model="resultModel.link"></v-textarea>
                      <v-btn outlined rounded @click="copyLink()">Copy link</v-btn>
                  </div>
                </div>
            </v-card-text>
        </v-card>
      </v-card>
      </v-col>
    </v-row>
      </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import MitUserManagementService from '../../services/MitUserManagementService.js';

  export default {
    name: 'MitAdminGenerateResetLinkPage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        resetChoices:[
            { name: 'Send email', id: 'email',hint:'Email a reset link to user' },
            { name: 'Create a link', id: 'link', hint:'Generate a reset link only' }
        ],
        changeModel:{
          username:'',
          expireTime:'360',
          resetPin:'',
          type:{ hint:''}
        },
        resultModel:{
          success:false,
          title:'',
          link:'',
          message:''
        },
        linkForm: {},
        valid:false,
        rules: {
          //rules for password come from backend since they are needed for api level validation, one set of rules for everyone :)
          username:[
              v => !!v || 'CSAIL username is required'
          ],
          expireTime:[
              v => !!v || 'Expire time is required'
          ],
          resetType:[
              v => !!v.id || 'Reset method is required'
          ]
        },
        loading:true,//making the request
        finished:false
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
    },
    methods: {
      copyLink(){
        let textarea = document.getElementById("mit-reset-link");
        textarea.select();
        document.execCommand("copy");
      },
      submit() {
        if(this.$refs.linkForm.validate()){
          this.finished = true;

          if(this.changeModel.type.id === 'email'){
              MitUserManagementService.requestPasswordResetByAdmin(this.changeModel.username, this.changeModel.resetPin, this.changeModel.expireTime)
                .then((result) => {
                  this.loading = false;
                  this.resultModel.success = true;
                  this.resultModel.title = 'Success';
                  this.resultModel.message = 'Email has been sent to the user.';
                })
                .catch((error) => {
                  this.resultModel.success = false;
                  this.resultModel.title = 'Error';
                  this.resultModel.message = 'Reason: '+error;

                  this.loading = false;
                });
          }
          else{
              MitUserManagementService.generateResetLink(this.changeModel.username, this.changeModel.resetPin, this.changeModel.expireTime)
              .then((result) => {
                this.loading = false;
                this.resultModel.success = true;
                this.resultModel.title = 'Success';
                this.resultModel.link = result;
              })
              .catch((error) => {
                this.resultModel.success = false;
                this.resultModel.title = 'Error';
                this.resultModel.message = 'Reason: '+error;

                this.loading = false;
              });
          }

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .fluid { width: 100%;}
</style>
